/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "place.stream.access.defs";

export { $nsid };

/** A capability a node grants to an account. admin: manage branding and access control (implies every other role). viewer: use the frontend and playback when the node is private. streamer: ingest media to this node. syndicate: have this account's media carried from other nodes. vod: upload and record VODs. */
type Role = "admin" | "viewer" | "streamer" | "syndicate" | "vod" | l.UnknownString;

export type { Role };

/** A capability a node grants to an account. admin: manage branding and access control (implies every other role). viewer: use the frontend and playback when the node is private. streamer: ingest media to this node. syndicate: have this account's media carried from other nodes. vod: upload and record VODs. */
const role = /*#__PURE__*/ l.string<{"knownValues":["admin","viewer","streamer","syndicate","vod"]}>();

export { role };

/** How a node decides a role. open: every account holds the role. allowlist: only accounts with a grant hold the role. off: nobody holds the role (admins are always exempt). */
type Mode = "open" | "allowlist" | "off" | l.UnknownString;

export type { Mode };

/** How a node decides a role. open: every account holds the role. allowlist: only accounts with a grant hold the role. off: nobody holds the role (admins are always exempt). */
const mode = /*#__PURE__*/ l.string<{"knownValues":["open","allowlist","off"]}>();

export { mode };

type RoleMode = { $type?: "place.stream.access.defs#roleMode";"role":Role;"mode":Mode };

export type { RoleMode };

const roleMode = /*#__PURE__*/ l.typedObject<RoleMode>($nsid, "roleMode", /*#__PURE__*/ l.object({"role":/*#__PURE__*/ l.ref<Role>((() => role) as any),"mode":/*#__PURE__*/ l.ref<Mode>((() => mode) as any)}));

export { roleMode };

/** One account's grant of one role. Grants stored as place.stream.access.grant records in the node's access-control space carry a uri and cid; grants seeded from the node's environment (SP_ADMIN_DIDS, SP_ALLOWED_STREAMS, SP_SYNDICATE) have no uri and cannot be revoked from the API. */
type GrantView = { $type?: "place.stream.access.defs#grantView";

  /**
   * at://{authority}/space/place.stream.access.control/self/{author}/place.stream.access.grant/{rkey} (A space URI; not validated as a classic at-uri because the space form is newer than that grammar.)
   */
  "uri"?:string;"cid"?:l.CidString;"subject":l.DidString;"role":Role;

  /**
   * space: a record in the access-control space, editable via the API. environment: seeded from the node's configuration.
   */
  "source":"space" | "environment" | l.UnknownString;

  /**
   * The admin that created the grant (the record's author).
   */
  "createdBy"?:l.DidString;"createdAt"?:l.DatetimeString;"note"?:string };

export type { GrantView };

/** One account's grant of one role. Grants stored as place.stream.access.grant records in the node's access-control space carry a uri and cid; grants seeded from the node's environment (SP_ADMIN_DIDS, SP_ALLOWED_STREAMS, SP_SYNDICATE) have no uri and cannot be revoked from the API. */
const grantView = /*#__PURE__*/ l.typedObject<GrantView>($nsid, "grantView", /*#__PURE__*/ l.object({"uri":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),"cid":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"cid"})),"subject":/*#__PURE__*/ l.string({"format":"did"}),"role":/*#__PURE__*/ l.ref<Role>((() => role) as any),"source":/*#__PURE__*/ l.string<{"knownValues":["space","environment"]}>(),"createdBy":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"did"})),"createdAt":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"datetime"})),"note":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"maxLength":1000,"maxGraphemes":100}))}));

export { grantView };

type PolicyView = { $type?: "place.stream.access.defs#policyView";

  /**
   * The effective mode of every role the node knows about, including environment overrides such as SP_WIDE_OPEN and SP_DISABLE_SYNDICATION.
   */
  "roles":(RoleMode)[] };

export type { PolicyView };

const policyView = /*#__PURE__*/ l.typedObject<PolicyView>($nsid, "policyView", /*#__PURE__*/ l.object({"roles":/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<RoleMode>((() => roleMode) as any), )}));

export { policyView };
